import { render, staticRenderFns } from "./LanguagesAddEdit.vue?vue&type=template&id=11c3ba96&scoped=true&"
import script from "./LanguagesAddEdit.vue?vue&type=script&lang=js&"
export * from "./LanguagesAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3ba96",
  null
  
)

export default component.exports